/**
 * Low-level RPC helper for XPR Network chain API calls.
 */

import { DEFAULT_API_URL } from './constants.js';

let currentApiUrl = DEFAULT_API_URL;

/**
 * Set the active API endpoint URL.
 * @param {string} url
 */
export function setApiUrl(url) {
  currentApiUrl = url;
}

/** Get the active API endpoint URL. */
export function getApiUrl() {
  return currentApiUrl;
}

/**
 * Make a POST request to an XPR Network RPC endpoint.
 *
 * @param {string} path  — e.g. '/v1/chain/get_info'
 * @param {object} [body={}]
 * @returns {Promise<any>}
 * @throws {Error} on non-2xx responses
 */
export async function rpc(path, body = {}) {
  const res = await fetch(currentApiUrl + path, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(`RPC ${path} failed (${res.status}): ${text}`);
  }

  return res.json();
}
